<app-view-company-details />
